import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, Input} from "reactstrap";
import {FormattedMessage} from "react-intl";
import LaddaButton, {ZOOM_OUT} from 'react-ladda';
import Switch from "components/Switch";


class ModalReject extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      saving: false,
      data: {
        msg: '',
        email: false,
        ban: false,
      }
    };

    this.cancel = this.cancel.bind(this);
    this.reject = this.reject.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal(){
    this.cancel();
  }

  cancel(){
    this.props.onCancel();
  }

  reject(){
    this.props.onReject(this.state.data);
  }

  render() {
    const {data} = this.state;

    return <Modal isOpen={true} toggle={this.toggleModal} size="md">
      <ModalHeader tag="h2" toggle={this.toggleModal}>Odrzuć ankietę</ModalHeader>
      <hr className="my-0" />
      <ModalBody>
        <Input type={"textarea"} onChange={(e) => this.setState({data: {...data, msg: e.target.value}})} value={data.msg}/>
        <div>
          <Switch onChange={value => this.setState({data: {...data, email: value}})} checked={data.email} /> Wyślij maila
        </div>
        <div>
          <Switch onChange={value => this.setState({data: {...data, ban: value}})} checked={data.ban} /> Zablokuj ponowne zgłaszanie ankiety do bazy
        </div>
      </ModalBody>
      <ModalFooter>
        <FormattedMessage id="_.button.cancel">{
          (message) =>
            <Button color="secondary" className="mb-0" onClick={this.cancel}>{message}</Button>
        }</FormattedMessage>
        <FormattedMessage id="_.button.reject">{
          (message) => <LaddaButton
            className="btn btn-primary btn-ladda mb-0"
            loading={false}
            data-style={ZOOM_OUT}
            onClick={() => this.reject()}
          >
            {message}
          </LaddaButton>
        }</FormattedMessage>
      </ModalFooter>
    </Modal>;
  }
}

ModalReject.propTypes = {
  onReject: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ModalReject;